import React from 'react';
import PropTypes from 'prop-types';
// import { connect } from 'react-redux';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import FormNumberRangeFieldEmbed from '../FormNumberRangeFieldEmbed/FormNumberRangeFieldEmbed';
// import { saveNumberRange, closeNumberRangeForm } from '../../store/modules/numberrange';
import { renderPreview } from '../../models/NumberRange';
import mergeStates from '../../helpers/mergeStates';

import classes from './FormNumberRange.scss';

/* const mapActionCreators = {
  saveNumberRange,
  closeNumberRangeForm
};

const mapStateToProps = (state) => ({
  numberRange: state.numberRange.numberRanges[state.numberRange.formTarget],
  fetching: state.numberRange.fetching,
  open: state.numberRange.formOpen,
  formTarget: state.numberRange.formTarget,
  user: state.login.user
}); */

class FormNumberRange extends React.Component {
  constructor(props) {
    super(props);

    const preppedNumberRange = {
      id: props.numberRange.id !== null ? props.numberRange.id : null,
      name: props.numberRange.name !== null ? props.numberRange.name : '',
      fields: props.numberRange.format !== null ? props.numberRange.format : [],
    };

    this.state = {
      id: preppedNumberRange.id,
      name: preppedNumberRange.name,
      fields: preppedNumberRange.fields,
    };

    setTimeout(() => this.focus(), 150);
  }

  componentDidMount() {
    if (
      typeof this.state.fields === 'undefined' ||
      this.state.fields.length === 0
    ) {
      this.addField();
    }
  }

  componentWillReceiveProps(nextProps) {}

  focus = () => {
    if (this.primaryInput && this.primaryInput !== null) {
      this.primaryInput.focus();
    }
  };

  handleChange = e => {
    const nextState = mergeStates(e, this.state);
    this.setState(nextState);
  };

  save = () => {
    // console.log(this.state);
    this.props.saveNumberRange(this.state);
    this.props.closeNumberRangeForm();
    this.props.push('/numberrange/');
  };

  addField = () => {
    const nextState = this.state;

    if (typeof nextState.fields === 'undefined' || nextState.fields === null) {
      nextState.fields = [];
    }

    nextState.fields.push({
      name: '',
      type: null,
      value: '',
    });

    this.setState(nextState);
  };

  applyFieldChange = (field, index) => {
    const nextState = this.state;
    nextState.fields[index] = field;

    this.setState(nextState);
  };

  removeField = index => {
    const nextState = this.state;
    nextState.fields.splice(index, 1);

    this.setState(nextState);
  };

  renderFields = () => {
    const fields = [];

    if (typeof this.state.fields !== 'undefined') {
      this.state.fields.forEach((detail, index) => {
        fields.push(
          <FormNumberRangeFieldEmbed
            key={`field_${index}`}
            field={detail}
            position={index}
            onChange={(field, index) => {
              this.applyFieldChange(field, index);
            }}
            onRemove={index => {
              this.removeField(index);
            }}
          />,
        );
      });
    }

    return fields;
  };

  render() {
    let preview = null;
    if (typeof this.state.fields !== 'undefined') {
      preview = renderPreview(this.state.fields, true);
    }

    let buttonText = 'Erstellen';
    if (this.state.id !== null) {
      buttonText = 'Speichern';
    }

    const actions = [
      <ul className={classes.formatList}>{preview}</ul>,
      <FlatButton
        label="Abbrechen"
        primary={false}
        onMouseDown={() => {
          this.props.closeNumberRangeForm();
        }}
      />,
      <FlatButton
        label={buttonText}
        primary
        disabled={this.state.name.trim().length === 0}
        onMouseDown={() => this.save()}
      />,
    ];

    let title = 'Neuen Nummernkreis erstellen';
    if (this.state.id !== null) {
      title = `"${this.state.name}" bearbeiten`;
    } else if (this.state.name.length) {
      title = `"${this.state.name}" erstellen`;
    }

    return (
      <Dialog
        title={title}
        actions={actions}
        modal={false}
        open
        autoScrollBodyContent
        className="form"
        contentClassName="form-container form-container--number-range"
        titleClassName="form-header"
        actionsContainerClassName="form-footer"
        bodyClassName="form-body"
      >
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="name">
              Name
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <input
              name="name"
              required
              value={this.state.name}
              onChange={e => this.handleChange(e)}
              ref={input => {
                this.primaryInput = input;
              }}
            />
            <p className="form-text text-muted">
              <small>
                Nummernkreise können derzeit nur bei Projekten verwendet werden.
              </small>
            </p>
          </div>
        </div>

        <div className={classes.fieldsWrapper}>{this.renderFields()}</div>

        <div className="row">
          <div className="col-xs-12 text-center">
            <a
              href="#addField"
              onMouseDown={() => {
                this.addField();
              }}
            >
              + Weiteres Feld hinzufügen
            </a>
          </div>
        </div>
      </Dialog>
    );
  }
}
FormNumberRange.propTypes = {
  numberRange: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  saveNumberRange: PropTypes.func.isRequired,
  closeNumberRangeForm: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
};
FormNumberRange.defaultProps = {
  numberRange: {
    id: null,
    name: '',
    fields: [],
  },
};
export default FormNumberRange;



// WEBPACK FOOTER //
// ./src/components/FormNumberRange/FormNumberRange.js